/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type Currency = "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "AUD" | "CAD" | "CHF" | "EUR" | "GBP" | "JPY" | "MXN" | "USD" | "%future added value";
export type PdpSharedMakeOfferButton_user = {
    readonly profile: {
        readonly currency: Currency | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"SharedContactDealerWrapper_user">;
    readonly " $refType": "PdpSharedMakeOfferButton_user";
};
export type PdpSharedMakeOfferButton_user$data = PdpSharedMakeOfferButton_user;
export type PdpSharedMakeOfferButton_user$key = {
    readonly " $data"?: PdpSharedMakeOfferButton_user$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedMakeOfferButton_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedMakeOfferButton_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "profile",
      "storageKey": null,
      "args": null,
      "concreteType": "Profile",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "currency",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "SharedContactDealerWrapper_user",
      "args": null
    }
  ]
};
(node as any).hash = '6566dfb682a0449e8b6d43ffa64a5175';
export default node;
